import { FC, useEffect, useState } from "react";

import { IconButton, Stack, TextField } from "@mui/material";

import DeleteIcon from '@mui/icons-material/Delete';

interface ImageSubNameComponentProps {
    array: string[];
    arrayIndex: number;
    deleteItem: (index: number) => void;
}

const ImageSubNameComponent: FC<ImageSubNameComponentProps> = ({ array, arrayIndex, deleteItem }) => {
    const [subName, setSubName] = useState<string>("");

    useEffect(() => {
        setSubName(array[arrayIndex]);
    }, [array, arrayIndex]);

    function SubnameChanged(event: any) {
        var value = event.target.value;
        setSubName(value);
        array[arrayIndex] = value;
    }

    return (
        <Stack
            direction={"row"}
            alignItems="center">
            <TextField
                value={subName}
                onChange={SubnameChanged}
                sx={{ minWidth: "245px" }}
                size="small" />
            <IconButton
                color="error"
                onClick={() => deleteItem(arrayIndex)}>
                <DeleteIcon />
            </IconButton>
        </Stack>
    )
}

export default ImageSubNameComponent;